import loveAndDrama from './love and drama.json';
import gettingAround from './getting_around.json';
import daily from './daily.json';
import relationships from './relationships.json';
import health from './health.json';

export const VocabularyPhrasal = [
  loveAndDrama,
  gettingAround,
  daily,
  relationships,
  health,
];